import React, { useState } from "react";
import { 
  EditOptionContainer, 
  EditOptionTitle, 
  EditOptionDescription, 
  FormGroup, 
  Button, 
  ButtonGroup,
  LoadingSpinner,
  TipBox,
  Switch,
  SelectBox
} from "../EditOptionStyles";
import { increaseResolution } from "../../utils/editUtils";

const IncreaseResolution = ({ onSubmit, isLoading }) => {
  const [scale, setScale] = useState("2");
  const [preserveDetails, setPreserveDetails] = useState(true);
  const [reduceNoise, setReduceNoise] = useState(false);
  const [sharpenEdges, setSharpenEdges] = useState(false);
  
  const scaleOptions = [
    { value: "2", label: "2x Resolution (Double)" },
    { value: "4", label: "4x Resolution (Quadruple)" }
  ];

  const handleSubmit = () => {
    onSubmit({
      editType: "increaseResolution",
      options: {
        desired_increase: parseInt(scale),
        preserve_details: preserveDetails,
        reduce_noise: reduceNoise,
        sharpen_edges: sharpenEdges
      },
      apiFunction: increaseResolution
    });
  };

  return (
    <EditOptionContainer>
      <div>
        <EditOptionTitle icon="🔍">Increase Resolution</EditOptionTitle>
        <EditOptionDescription>
          Enhance your image quality by increasing resolution while preserving important details and reducing artifacts.
        </EditOptionDescription>
      </div>

      <FormGroup label="Resolution Scale">
        <SelectBox 
          options={scaleOptions} 
          value={scale} 
          onChange={(e) => setScale(e.target.value)} 
        />
      </FormGroup>

      <FormGroup label="Enhancement Options">
        <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
          <Switch 
            checked={preserveDetails} 
            onChange={setPreserveDetails} 
            label="Preserve Fine Details" 
          />
          <Switch 
            checked={reduceNoise} 
            onChange={setReduceNoise} 
            label="Reduce Image Noise" 
          />
          <Switch 
            checked={sharpenEdges} 
            onChange={setSharpenEdges} 
            label="Sharpen Edges" 
          />
        </div>
      </FormGroup>

      <TipBox 
        title="Best Results" 
        icon="💡"
      >
        For optimal quality, enable "Preserve Fine Details" and consider reducing noise for older or compressed images.
      </TipBox>

      <ButtonGroup>
        <Button 
          primary={false} 
          outline={true}
          onClick={() => {
            setScale("2");
            setPreserveDetails(true);
            setReduceNoise(false);
            setSharpenEdges(false);
          }}
        >
          Reset
        </Button>
        <Button 
          onClick={handleSubmit} 
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <LoadingSpinner />
              Processing...
            </>
          ) : (
            "Increase Resolution"
          )}
        </Button>
      </ButtonGroup>
    </EditOptionContainer>
  );
};

export default IncreaseResolution;
